import storage from './storage';

const KEY = uid => `crm_email_signature_${uid || 'default'}`;

export const emailSignatureService = {
  get(userId) {
    return storage.get(KEY(userId), '');
  },
  set(userId, text) {
    storage.set(KEY(userId), text || '');
  },
};
